import { render } from "./PremiosView.vue?vue&type=template&id=5f6c0143&scoped=true"
import script from "./PremiosView.vue?vue&type=script&lang=js"
export * from "./PremiosView.vue?vue&type=script&lang=js"

import "./PremiosView.vue?vue&type=style&index=0&id=5f6c0143&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6c0143"]])

export default __exports__